import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle } from 'lucide-react';
const painPoints = ['Llegás a la clase sin saber exactamente qué secuencia vas a dar hoy', 'Tus alumnos no progresan porque no tenés una estructura clara de postura en postura', 'El 40% abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre las mismas 10 o 15 posturas de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Siempre las mismas correcciones improvisadas, sin un método claro que te respalde', 'Tenés alumnos de distintos niveles juntos y la clase se convierte en un caos', 'Fin de mes y los alumnos se van sin avisar porque la comunicación es inconsistente'];
export function PainPoints() {
  return <section className="py-12 md:py-24 bg-white" data-id="element-247">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-248">
        <motion.div className="text-center mb-8 md:mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-249">
          <div className="inline-flex items-center justify-center p-2 md:p-3 bg-red-50 rounded-full mb-4 md:mb-6" data-id="element-250">
            <AlertTriangle className="w-6 h-6 md:w-8 md:h-8 text-red-500" data-id="element-251" />
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-gray-900" data-id="element-252">
            Si sos profe de Yoga en Argentina, esto te va a sonar familiar:
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3 md:gap-y-6" data-id="element-253">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-3 p-2 md:p-4 rounded-xl hover:bg-gray-50 transition-colors" data-id="element-254">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-255" />
              <p className="text-sm md:text-base text-gray-700 leading-relaxed" data-id="element-256">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div className="mt-8 md:mt-16 text-center" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} data-id="element-257">
          <h3 className="text-xl md:text-3xl font-bold text-yoga-purple-900 bg-yoga-purple-50 inline-block px-5 py-3 md:px-8 md:py-4 rounded-2xl border border-yoga-purple-100 shadow-sm" data-id="element-258">
            ¿Cuántas clases más vas a improvisar?
          </h3>
        </motion.div>
      </div>
    </section>;
}